import React from 'react';
import { Form, Input, Select, Check } from '@rocketseat/unform';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { toast } from 'react-toastify';
import { Container, GroupHeader, Group, CheckRow } from './styles';
import api from '~/services/api';
import history from '~/services/history';

export default function VehicleEditor({ location }) {
  const { pathname, state } = location;
  const edit = pathname === '/vehicle/edit';
  const item = state && location.state.item ? location.state.item : undefined;
  const schema = Yup.object().shape({
    vin: Yup.string().required('This field is required'),
    make: Yup.string().required('This field is required'),
    model: Yup.string().required('This field is required'),
    year: Yup.number()
      .positive()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue.trim() === '' ? null : value;
      })
      .required('This field is required'),
    trim: Yup.string().required('This field is required'),
    bodyType: Yup.string().required('This field is required'),
    doors: Yup.number()
      .positive()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue.trim() === '' ? null : value;
      })
      .required('This field is required'),
    exteriorColor: Yup.string(),
    interiorColor: Yup.string(),
    engine: Yup.string(),
    fuel: Yup.string(),
    drivetrain: Yup.string(),
    transmission: Yup.string(),
    mileage: Yup.number()
      .positive()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue.trim() === '' ? null : value;
      })
      .required('This field is required'),
    price: Yup.number()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue.trim() === '' ? null : value;
      })
      .required('This field is required'),
    uber: Yup.bool(),
    title: Yup.bool(),
    featured: Yup.bool(),
    GPS_1: Yup.lazy(value =>
      value === '' ? Yup.string().strip(true) : Yup.string()
    ),
    GPS_2: Yup.lazy(value =>
      value === '' ? Yup.string().strip(true) : Yup.string()
    ),
  });
  const handleSubmit = async (data, { resetForm }) => {
    try {
      if (edit) {
        await api.put(`/vehicle/${item.id}`, data);
        toast.success(`Vehicle was successfully updated.`);
      } else {
        await api.post(`/vehicle`, data);
        toast.success(`Vehicle was successfully created.`);
      }
      resetForm();
      history.push({
        pathname: '/inventory',
      });
    } catch (err) {
      toast.error(
        err.response &&
          err.response.data &&
          err.response.data.error &&
          typeof err.response.data.error === 'string'
          ? err.response.data.error
          : `Error while ${edit ? 'editing' : 'creating'} the vehicle`
      );
    }
  };

  return (
    <Container>
      <Form
        schema={schema}
        initialData={item}
        context={{ edit }}
        onSubmit={handleSubmit}
      >
        <GroupHeader>Images</GroupHeader>
        <Group>DEVELOPMENT</Group>
        <GroupHeader>Vehicle Information</GroupHeader>
        <Group>
          <Input label="VIN" name="vin" />
          <Input label="Make" name="make" />
          <Input label="Model" name="model" />
          <Input label="Year" type="number" name="year" min="2000" max="2100" />
          <Input label="Body Type" name="bodyType" />
          <Input label="Doors" type="number" name="doors" />
          <Input label="Trim" name="trim" />
          <Input label="Exterior Color" name="exteriorColor" />
          <Input label="Interior Color" name="interiorColor" />
          <Input label="Engine" name="engine" />
          <Select
            label="Fuel"
            name="fuel"
            options={[
              { id: 'GASOLINE', title: 'GASOLINE' },
              { id: 'DIESEL', title: 'DIESEL' },
              { id: 'FLEX', title: 'FLEX' },
              { id: 'HYBRID', title: 'HYBRID' },
              { id: 'ELETRIC', title: 'ELETRIC' },
            ]}
          />
          <Input label="Drive Train" name="drivetrain" />
          <Select
            label="Transmission"
            name="transmission"
            options={[
              { id: 'AUTOMATIC', title: 'AUTOMATIC' },
              { id: 'MANUAL', title: 'MANUAL' },
            ]}
          />
          <Input label="Mileage" name="mileage" />
          <Input label="Price" name="price" type="number" min="0" />
          <CheckRow>
            <Check label="Uber" name="uber" />
          </CheckRow>
          <CheckRow>
            <Check label="Title" name="title" />
          </CheckRow>
          <CheckRow>
            <Check label="Featured" name="featured" />
          </CheckRow>
        </Group>
        <GroupHeader>GPS</GroupHeader>
        <Group>
          <Input label="GPS #1" name="GPS_1" />
          <Input label="GPS #2" name="GPS_2" />
        </Group>
        <button type="submit">{edit ? 'Edit' : 'Confirm'}</button>
      </Form>
    </Container>
  );
}
VehicleEditor.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      item: PropTypes.shape(),
    }),
  }).isRequired,
};
